export const cn = (...names: string[]) => names.join(" ");
